import request from "@/utils/request";
import { apiConfig } from "../config/api";

// 分页查询考场
export function getExamPager(req, pager) {
  return request({
    url: apiConfig.examApi.api.getExamPager.url,
    method: "post",
    data: {
      ...req,
      ...pager
    }
  });
}
// 根据id查询考场
export function getExam(id) {
  return request({
    url: apiConfig.examApi.api.getExam.url + id,
    method: "get",
  });
}
// 保存考场信息草稿
export function saveInfoDraft(data) {
  return request({
    url: apiConfig.examApi.api.saveInfoDraft.url,
    method: "post",
    data
  });
}
// 修改考场信息-仅暂停的考场可以修改部分字段
export function saveInfoEdit(data) {
  return request({
    url: apiConfig.examApi.api.saveInfoEdit.url,
    method: "post",
    data
  });
}
// 提交考场草稿
export function submitExam(params) {
  return request({
    url: apiConfig.examApi.api.submitExam.url,
    method: "post",
    params
  });
}
// 删除考场-仅草稿状态可以删除
export function deleteExam(params) {
  return request({
    url: apiConfig.examApi.api.deleteExam.url,
    method: "post",
    params
  });
}
// 查询考场可选量表列表
export function getScaleOptions(params) {
  return request({
    url: apiConfig.examScaleApi.api.getScaleOptions.url,
    method: "get",
    params
  });
}
// 查询考场量表列表
export function getExamScaleList(params) {
  return request({
    url: apiConfig.examScaleApi.api.getExamScaleList.url,
    method: "get",
    params
  });
}
// 查询考场量表基础信息
export function queryExamScaleConfigInfo(id) {
  return request({
    url: apiConfig.examScaleApi.api.queryExamScaleConfigInfo.url + id,
    method: "get",
  });
}
// 保存考场量表基础信息草稿
export function saveExamScaleBaseInfoDraft(data) {
  return request({
    url: apiConfig.examScaleApi.api.saveExamScaleBaseInfoDraft.url,
    method: "post",
    data
  });
}
// 保存考场量表题目信息草稿
export function saveExamScaleSubjectDraft(params) {
  return request({
    url: apiConfig.examScaleApi.api.saveExamScaleSubjectDraft.url,
    method: "post",
    params
  });
}
// 保存考场量表试卷配置草稿
export function saveExamScaleSubjectConfigDraft(data) {
  return request({
    url: apiConfig.examScaleApi.api.saveExamScaleSubjectConfigDraft.url,
    method: "post",
    data
  });
}
// 提交考场量表草稿
export function submitExamScale(params) {
  return request({
    url: apiConfig.examScaleApi.api.submitExamScale.url,
    method: "post",
    params
  });
}
// 分页查询考场量表题库
export function getExamScaleSubjectPager(examScaleId, data) {
  return request({
    url: apiConfig.examScaleSubjectApi.api.getExamScaleSubjectPager.url,
    method: "post",
    params: {
      examScaleId
    },
    data
  });
}
// 根据id查询考场量表题目
export function getExamScaleSubject(id) {
  return request({
    url: apiConfig.examScaleSubjectApi.api.getExamScaleSubject.url + id,
    method: "get",
  });
}
// 修改考场量表题目
export function updateExamScaleSubject(data) {
  return request({
    url: apiConfig.examScaleSubjectApi.api.updateExamScaleSubject.url,
    method: "post",
    data
  });
}
// 删除考场量表题目
export function deleteExamScaleSubject(params) {
  return request({
    url: apiConfig.examScaleSubjectApi.api.deleteExamScaleSubject.url,
    method: "post",
    params
  });
}
// 批量删除考场量表题目
export function batchDeleteExamScaleSubject(data) {
  return request({
    url: apiConfig.examScaleSubjectApi.api.batchDeleteExamScaleSubject.url,
    method: "post",
    data
  });
}
// 获取分类列表
export function getExamScaleSubjectGroupByType(params) {
  return request({
    url: apiConfig.examScaleSubjectApi.api.getExamScaleSubjectGroupByType.url,
    method: "get",
    params
  });
}
export function changeSort(examScaleId, id, params) {
  return request({
    url: apiConfig.examScaleSubjectApi.api.changeSort.url(examScaleId, id),
    method: "post",
    params,
  })
}

export function getExamListByAgentId(agentId) {
  return request({
    url: apiConfig.examApi.api.getExamListByAgentId.url + agentId,
    method: "get",
  });
}

export function bindExam(data) {
  return request({
    url: apiConfig.examApi.api.bindExam.url,
    method: "post",
    data
  })
}

export function getScaleRanking(data){
  return request({
    url: apiConfig.examApi.api.getScaleRanking.url,
    method: "post",
    data
  })
}
export function getUserScaleRankingByCondition(data){
  return request({
    url: apiConfig.examApi.api.getUserScaleRankingByCondition.url,
    method: "post",
    data
  })
}
export function startOrStopExam(id){
  return request({
    url: apiConfig.examApi.api.startOrStopExam.url(id),
    method: "post",
  })
}

export function exportResetUserInfo(params) {
  return request({
    url: apiConfig.examApi.api.exportResetUserInfo.url,
    method: "get",
    params,
    responseType: "blob"
  })
}

export function resetUserScaleSelection(data) {
  return request({
    url: apiConfig.examApi.api.resetUserScaleSelection.url,
    method: "post",
    data
  })
}
export function exportUserExamMajorScore(params) {
  return request({
    url: apiConfig.examApi.api.exportUserExamMajorScore.url,
    method: "get",
    params,
    responseType: "blob"
  })
}
export function viewExamUrl(examId) {
  return request({
    url: apiConfig.examApi.api.viewExamUrl.url(examId),
    method: "get"
  });
}
export function getExamUserPager(data) {
  return request({
    url: apiConfig.examApi.api.getExamUserPager.url,
    method: 'post',
    data,
  });
}

export function examUserListExport(data) {
  return request({
    url: apiConfig.examApi.api.examUserListExport.url,
    method: 'post',
    data,
    responseType: "blob"
  });
}
export function getAddSubjectPager(data) {
  return request({
    url: apiConfig.examScaleSubjectApi.api.getAddSubjectPager.url,
    method: "post",
    data
  })
}
export function findSubjectChooseGroup(data) {
  return request({
    url: apiConfig.examScaleSubjectApi.api.findSubjectChooseGroup.url,
    method: "post",
    data
  })
}
export function choseSubjectByType(data) {
  return request({
    url: apiConfig.examScaleSubjectApi.api.choseSubjectByType.url,
    method: "post",
    data
  })
}
export function createBySubjectIdList(examScaleId, data) {
  return request({
    url: apiConfig.examScaleSubjectApi.api.createBySubjectIdList.url(examScaleId),
    method: "post",
    data
  })
}
export function delBySubjectIdList(examScaleId, data) {
  return request({
    url: apiConfig.examScaleSubjectApi.api.delBySubjectIdList.url(examScaleId),
    method: "post",
    data
  })
}
export function examList(params) {
  return request({
    url: apiConfig.examApi.api.examList.url,
    method: "get",
    params
  });
}
export function copyExam(params) {
  return request({
    url: apiConfig.examApi.api.copyExam.url,
    method: "post",
    params
  });
}
export function profile() {
  return request({
    url: apiConfig.examStatistics.api.profile.url,
    method: "get"
  });
}
export function detailPager(data) {
  return request({
    url: apiConfig.examStatistics.api.detail.url.pager,
    method: "post",
    data
  });
}
export function examUserPager(data) {
  return request({
    url: apiConfig.examStatistics.api.detail.url.examUserPager,
    method: "post",
    data
  });
}
export function downloadExamDetail(req) {
  return request({
    url: apiConfig.examStatistics.api.detail.url.downloadExamDetail,
    method: "post",
    data: {
      agentIds: req.agentIds
    },
    responseType: "blob"
  });
}
export function getExamAgentList(params) {
  return request({
    url: apiConfig.examApi.api.getExamAgentList.url,
    method: "get",
    params
  });
}
export function getExamAgentFinishPager(data) {
  return request({
    url: apiConfig.examApi.api.getExamAgentFinishPager.url,
    method: "post",
    data
  });
}
